// src/store/redux/slices/preferencesSlice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ProjectOptionsLabels } from '../../../types/types'
import { WritableDraft } from 'immer'
import { PURGE } from 'redux-persist/es/constants'

export type FilterSelections = {
  [key in ProjectOptionsLabels]: FilterState
}

interface FilterState {
  [key: string]: boolean
}

export type FilterVarious = {
  partner: boolean
  full: boolean
  break: boolean
}
export interface PreferencesState {
  filterSelections: FilterSelections
  filterOpenAccess: boolean
  filterVarious: FilterVarious
  isLoading: boolean
  error: string | null
}

export const initialState: PreferencesState = {
  filterSelections: {
    days: {},
    tags: {},
    locations: {},
  },
  filterOpenAccess: false,
  filterVarious: {
    partner: false,
    full: false,
    break: false,
  },
  isLoading: false,
  error: null,
}

const preferencesSlice = createSlice({
  name: 'preferences',
  initialState,
  reducers: {
    toggleFilterItem: (
      state: WritableDraft<PreferencesState>,
      action: PayloadAction<{ category: ProjectOptionsLabels; label: string }>,
    ) => {
      const { category, label } = action.payload
      const isSelected: boolean = state.filterSelections[category]?.[label] || false
      state.filterSelections[category][label] = !isSelected
    },
    setFilterOpenAccess: (state: WritableDraft<PreferencesState>, action: PayloadAction<boolean>) => {
      state.filterOpenAccess = action.payload
    },
    toggleVariousItem: (
      state: WritableDraft<PreferencesState>,
      action: PayloadAction<{ categoryVarious: keyof FilterVarious }>,
    ) => {
      const { categoryVarious } = action.payload
      state.filterVarious[categoryVarious] = !state.filterVarious[categoryVarious]
    }
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState)
  },
})

export const { toggleFilterItem, setFilterOpenAccess, toggleVariousItem } = preferencesSlice.actions
export default preferencesSlice.reducer
